import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { corrections } from 'src/app/core/translations/corrections';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-correction',
  templateUrl: './correction.component.html',
  styleUrls: ['./correction.component.scss'],
})
export class CorrectionComponent implements OnInit {
  isHandsetPortrait: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';
  currentLanguage: string = '';
  languageTranslations: any = corrections;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }
  }
  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
